// extracted by mini-css-extract-plugin
export default {"modalHeadImg":"show_modalHeadImg__48csr"};